import { React, useEffect, useRef, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

import "../Style.css";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import CreateCompany from "./CreateCompany";
import CryptoJS from "crypto-js";
import WebsiteProgressSteps from "./WebsiteProgressSteps";

import { toast } from "react-toastify";
import { fetchBusinessList, deleteData } from "../services/apiService";
import { getUserInfo, setUserInfo, setCurrentCompanyId } from "../utils/auth";
import { Hr } from "react-flags-select";

const Landing = () => {
  const [recordList, setRecordList] = useState([]);
  const recordListRef = useRef(recordList);
  const [companyId, setCompanyId] = useState("");
  const [websiteName, setWebsiteName] = useState("");

  const [role, setRole] = useState("");
  const [userEmail, setUserEmail] = useState("");

  const deleteRecord = async (id) => {
    if (window.confirm("Are you sure for deleting this record ?")) {
      try {
        await deleteData("api/v1/delete?id=" + id);
        toast.success("Deleted, Successfully.");
        loadData();
      } catch (error) {
        toast.error("Failed to load data", error);
      }
    }
  };

  const loadData = async () => {
    try {
      const result = await fetchBusinessList("api/v1/list");
      if (result.success) {
        setRecordList(result.data);
        if (result.data.length == 1) {
          setWebsiteName(result.data[0].websiteName);
          setCompanyId(result.data[0].id);
          setCurrentCompanyId(result.data[0].id);
        }
      } else if (!result.success) {
        toast.error(result.message);
      }
    } catch (error) {
      toast.error("Failed to load data", error);
    }
  };

  const setUserDetails = () => {
    const userInfo = getUserInfo();
    const ENCRYPT_DECRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY;
    const bytes = CryptoJS.AES.decrypt(userInfo, ENCRYPT_DECRYPTION_KEY);
    const decryptedUserDetails = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    setRole(decryptedUserDetails.role);
    setUserEmail(decryptedUserDetails.email);
  };

  useEffect(() => {
    loadData();
    setUserDetails();
  }, []);

  return (
    <div className="container">
      <Header />
      <div className="container-fluid">
        <div className="row">
          <Sidebar />

          <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
              {role == "ROLE_USER" ? (
                <h4>Your Business/Orgnisation Details</h4>
              ) : (
                <h2>List of Leads</h2>
              )}
            </div>

            {recordList.length == 0 && <CreateCompany email={userEmail} />}
            {recordList.length > 0 && (
              <div className="row  g-3">
                {role == "ROLE_USER" ? (
                  <div>
                    {recordList.map((record, index) => (
                      <div className="col">
                        <div className="card" style={{ width: "18rem" }}>
                          {record.logo == "" ? (
                            <img
                              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOOvKfUx_ihZTPIfobQQWFT_nQUrFj1ZnXzQ&usqp=CAU"
                              className="card-img-top"
                              style={{
                                maxWidth: "100%",
                                maxHeight: "100px",
                                display: "block",
                              }}
                            ></img>
                          ) : (
                            <img
                              src={record.logo}
                              className="card-img-top"
                              style={{
                                maxWidth: "100%",
                                maxHeight: "100px",
                                display: "block",
                              }}
                            />
                          )}
                          <div className="card-body">
                            <h5 className="card-title">{record.websiteName}</h5>
                          </div>
                          <ul className="list-group list-group-flush">
                            <li className="list-group-item">
                              Language: {record.language}
                            </li>
                            <li className="list-group-item">
                              Contact Name : {record.contactName}
                            </li>
                          </ul>
                          <div className="card-body text-align-center">
                            <Link
                              to={`/company-detail/${record.id}`}
                              className="btn btn-primary  card-link m-2"
                            >
                              View
                            </Link>

                            <Link
                              to={`/company-detail-update/${record.id}`}
                              className="btn btn-info card-link  m-2"
                            >
                              Update
                            </Link>
                            {role == "ROLE_USER" ? (
                              ""
                            ) : (
                              <Link
                                className="btn btn-danger card-link  m-2"
                                onClick={(e) => deleteRecord(record.id)}
                              >
                                Delete
                              </Link>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="col">
                    <table className="table">
                      <thead className="thead-dark">
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Logo</th>
                          <th scope="col">Website Name</th>
                          <th scope="col">Contact Name</th>
                          <th scope="col">Language</th>
                          <th scope="col">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {recordList.map((record, index) => (
                          <tr>
                            <th scope="row">{index}</th>
                            <td>
                              {record.logo == "" ? (
                                <img
                                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOOvKfUx_ihZTPIfobQQWFT_nQUrFj1ZnXzQ&usqp=CAU"
                                  className="card-img-top"
                                  style={{
                                    maxWidth: "100%",
                                    maxHeight: "300px",
                                    display: "block",
                                  }}
                                ></img>
                              ) : (
                                <img
                                  src={record.logo}
                                  className="card-img-top"
                                  style={{
                                    maxWidth: "250px",
                                    maxHeight: "150px",
                                    display: "block",
                                  }}
                                />
                              )}
                            </td>
                            <td>{record.websiteName}</td>
                            <td>{record.contactName}</td>
                            <td> {record.language}</td>
                            <td>
                              <Link
                                to={`/company-detail/${record.id}`}
                                className="btn btn-primary  card-link m-2"
                              >
                                View
                              </Link>

                              <Link
                                to={`/company-detail-update/${record.id}`}
                                className="btn btn-info card-link  m-2"
                              >
                                Update
                              </Link>
                              {role == "ROLE_USER" ? (
                                ""
                              ) : (
                                <Link
                                  className="btn btn-danger card-link  m-2"
                                  onClick={(e) => deleteRecord(record.id)}
                                >
                                  Delete
                                </Link>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {role == "ROLE_USER" && <WebsiteProgressSteps />}
          </main>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Landing;
